import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ea1036"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-1 mb-4 ps-5 pe-5 justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"bf-content\" data-v-78ea1036><div class=\"bf-eyebrow\" data-v-78ea1036><img src=\"/media/hc/bf-hc-logo-white.png\" class=\"bf-logo\" alt=\"Hacking Club\" data-v-78ea1036><span data-v-78ea1036>Black Friday 2026</span></div><h2 class=\"bf-title\" data-v-78ea1036>Black Friday com 50% de desconto!</h2><p class=\"bf-subtitle\" data-v-78ea1036>Clique para garantir a oferta.</p></div><span class=\"bf-button\" data-v-78ea1036>Acesse aqui →</span>", 2)
const _hoisted_4 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const LP_URL = "https://blackfriday.hackingclub.com/";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "bf-banner",
      href: LP_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "Black Friday 2026: cadastre-se e receba as infos antes"
    }, _hoisted_4)
  ]))
}
}

})